import React from 'react';

import CartLayout from './CartLayout';
import EnableSubstitutionLoader from './EnableSubstitution/EnableSubstitutionLoader';
import CartListLoader from './CartList/CartListLoader';

const CartLoader: React.FC = () => (
  <CartLayout>
    <EnableSubstitutionLoader />
    <CartListLoader />
  </CartLayout>
);

export default CartLoader;
